export const defaultData = {
	email_verification: {
		enable: "yes",
		verification_page_id: "none",
		redirect_after_verification: "none",
		login_after_verification: "yes",
		email_update_reverify: "no",
		exclude_user_roles: ["administrator"],
	},
	messages: {
		invalid_key: "Sorry, activation key is not valid.",
		activation_sent: "Verification mail has been sent.",
		verify_email: "Verify your email first!",
		registration_success:
			'Registration complete. Please verify the mail first, then visit the <a href="%s">login page</a>.',
		verification_success: "Thanks for Verifying.",
		verification_fail: "Sorry! Verification failed.",
		please_wait: "Please wait.",
		mail_instruction:
			"Please check your mail inbox and follow the instruction. don\\'t forget to check spam or trash folder.",
		redirect_after_verify: "You will redirect after verification",
		not_redirect: "Click if not redirect automatically",
		title_checking_verification: "Checking Verification",
		title_sending_verification: "Sending verification mail",
		captcha_error: "Captcha not resolved.",
		otp_sent_success: "OTP has been sent successfully.",
		otp_sent_error: "OTP generated, but unable to send mail.",
	},
	email_otp: {
		enable_default_login: "no",
		required_email_verified: "no",
		allow_password: "yes",
		length: "6",
		character_source: ["uppercase", "lowercase"],
	},
	isspammy: {
		report_comment_spam: "no",
		report_comment_trash: "no",
		block_comment: "no",
		comment_form_notice: "no",
		comment_form_notice_text: "",
		block_register: "no",
		block_login: "no",
	},
	spam_protection: {
		enable_domain_block: "no",
		blocked_domain: [""],
		allowed_domain: [""],
		enable_username_block: "no",
		blocked_username: [""],
		generic_mail_block: "no",
		blocked_generic_mail: [""],
	},
	logo_id: "69",
	mail_wpautop: "yes",
	email_templates_data: {
		user_registered: {
			name: "New User Registration",
			enable: "yes",
			email_bcc: "",
			email_from_name: "Wordpress",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "New user submitted - {site_url}",
			html: '<div style="background: #f5f5f5;color: #333;font-size: 14px;line-height: 20px;font-family: Arial, sans-serif">\r\n<div style="width: 600px;margin: 0 auto">\r\n<div class="header" style="border-bottom: 1px solid #ddd;padding: 20px 0;text-align: center"><strong style="font-size: 20px">{site_name}</strong></div>\r\n<div class="content" style="padding: 10px 0 40px">\r\n<p style="font-size: 14px;line-height: 20px;color: #333;font-family: Arial, sans-serif">Hello {user_name}, Did you forget to verify your account.</p>\r\n\r\n<h4 style="font-size: 14px;line-height: 20px;color: #333;font-family: Arial, sans-serif"><em><span style="color: #333333;font-family: Arial, sans-serif">Please verify your account by clicking the link below</span></em></h4>\r\n<p style="font-size: 14px;line-height: 20px;color: #333;font-family: Arial, sans-serif"><a class="btn" style="color: #fff;border-radius: 3px;text-decoration: none;background-color: #51b3ff;padding: 10px 20px;font-size: 14px;font-family: Arial, sans-serif" href="{ac_activaton_url}">Activate account</a></p>\r\n\r\n</div>\r\n<div class="footer" style="border-top: 1px solid #ddd;padding: 20px 0;clear: both;text-align: center"><small style="font-size: 11px">{site_name} - {site_description}</small></div>\r\n</div>\r\n</div>',
		},
		email_confirmed: {
			name: "Email Verification Confirmed",
			enable: "yes",
			email_bcc: "",
			email_from_name: "Wordpress",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "New user confirmed - {site_url}",
			html: '&nbsp;\r\n<div style="background: #f5f5f5;color: #333;font-size: 14px;line-height: 20px;font-family: Arial, sans-serif">\r\n<div style="width: 600px;margin: 0 auto">\r\n<div class="header" style="border-bottom: 1px solid #ddd;padding: 20px 0;text-align: center">\r\n\r\n<strong style="font-size: 20px">{site_name}</strong>\r\n\r\n</div>\r\n<div class="content" style="padding: 10px 0 40px">\r\n<p style="font-size: 14px;line-height: 20px;color: #333;font-family: Arial, sans-serif">{user_name} has successfully joined to {site_name}</p>\r\n\r\n</div>\r\n<div class="footer" style="border-top: 1px solid #ddd;padding: 20px 0;clear: both;text-align: center"><small style="font-size: 11px">{site_name} - {site_description}</small></div>\r\n</div>\r\n</div>',
		},
		email_resend_key: {
			name: "Resend Activation Key",
			enable: "yes",
			email_bcc: "",
			email_from_name: "Wordpress",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "Please verify account - {site_url}",
			html: 'Hi {user_name},\r\n\r\nThank you for signing up! Please verify your email address by clicking the link below:\r\n\r\n<a class="btn" href="{ac_activaton_url}">Verify My Email</a>\r\n\r\nThis link will expire in 24 hours. If you didn’t create this account, please ignore this email.\r\n\r\nWelcome aboard,\r\n\r\n{site_name} - {site_description}',
		},
		send_mail_otp: {
			name: "Send Mail OTP",
			enable: "yes",
			email_bcc: "",
			email_from_name: "Wordpress",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "OTP - {site_url}",
			html: "Hi {user_name},\r\n\r\nYour one-time password (OTP) is: <strong>{otp_code}</strong>\r\n\r\nThis code is valid for the next 10 minutes. Please use it to complete your verification.\r\n\r\nIf you didn\\'t request this, please ignore this email.\r\n\r\nThank you,\r\n\r\n{site_name} - {site_description}",
		},
		send_magic_login_url: {
			name: "Send Magic Login URL",
			enable: "yes",
			email_bcc: "",
			email_from_name: "Wordpress",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "Magic Login - {site_url}",
			html: 'Hi <strong>{user_name}</strong>,\r\n\r\nClick the link below to securely log in to your account—no password needed!\r\n\r\n<strong><a href="{magic_login_url}">Magic Login</a></strong>\r\n\r\nThis link is valid for the next 15 minutes. If you didn\\\'t request this, please ignore this email.\r\n\r\nThanks,\r\n\r\n{site_name} - {site_description}',
		},
	},
	recaptcha: {
		version: "v2_checkbox",
		sitekey: "",
		secretkey: "",
		default_login_page: "no",
		default_registration_page: "no",
		default_lostpassword_page: "no",
		comment_form: "no",
	},
	unverified: {
		delete_user: "no",
		delete_max_number: "20",
		delay: "720",
		delete_user_interval: "daily",
		existing_user_verified: "no",
		existing_user_verified_interval: "daily",
	},
	disable: {
		new_user_notification_email: "no",
	},
	tools: {
		mail_from: "",
		mail_from_name: "",
	},
};